var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search 1",
    clipPath: "url(#clip0_27596_5170)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.879 15.3693C18.2709 13.4699 18.8943 11.115 18.6245 8.77568C18.3547 6.43638 17.2116 4.2852 15.4239 2.75253C13.6361 1.21985 11.3356 0.418708 8.98253 0.509376C6.62947 0.600044 4.3974 1.57584 2.7329 3.24153C1.06839 4.90723 0.0941984 7.13999 0.00521455 9.49311C-0.0837693 11.8462 0.71902 14.1462 2.25297 15.9328C3.78693 17.7195 5.93892 18.8611 8.27842 19.1292C10.6179 19.3973 12.9724 18.7722 14.8708 17.3789H14.8693C14.9124 17.4364 14.9585 17.491 15.0102 17.5442L20.5446 23.0786C20.8141 23.3483 21.1798 23.4999 21.5611 23.5001C21.9424 23.5002 22.3082 23.3489 22.5779 23.0793C22.8477 22.8098 22.9993 22.4441 22.9994 22.0628C22.9995 21.6815 22.8482 21.3157 22.5786 21.046L17.0443 15.5116C16.9929 15.4596 16.9376 15.4115 16.879 15.3678V15.3693ZM17.2498 9.84353C17.2498 10.8818 17.0453 11.9099 16.648 12.8691C16.2507 13.8283 15.6683 14.6999 14.9341 15.4341C14.2 16.1683 13.3284 16.7506 12.3692 17.148C11.4099 17.5453 10.3818 17.7498 9.34358 17.7498C8.30531 17.7498 7.27722 17.5453 6.31799 17.148C5.35875 16.7506 4.48718 16.1683 3.75301 15.4341C3.01885 14.6999 2.43648 13.8283 2.03915 12.8691C1.64183 11.9099 1.43733 10.8818 1.43733 9.84353C1.43733 7.74666 2.2703 5.73567 3.75301 4.25297C5.23572 2.77026 7.24671 1.93728 9.34358 1.93728C11.4404 1.93728 13.4514 2.77026 14.9341 4.25297C16.4168 5.73567 17.2498 7.74666 17.2498 9.84353Z",
    fill: "#CCCCCC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27596_5170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.27418ee63f49836db1dd56cb3d610526.svg";
export { ForwardRef as ReactComponent };